import { showErrorToast } from "../utils/toast";
import http from "./http";

async function login(user) {
  let formData = new FormData();
  formData.append("email", user.email);
  formData.append("password", user.password);
  const { data: response } = await http.post("/users/login", formData);
  return response;
}

async function register(user) {
  let formData = new FormData();
  formData.append("email", user.email);
  formData.append("password", user.password);
  formData.append("name", user.name);

  const { data: response } = await http.post("/users", formData);
  return response;
}

async function verifyAccount(user) {
  let data = {};
  data.email = user.email;
  data.hash = user.hash;

  const { data: response } = await http.put("/users/verify", data);
  return response;
}

function logout() {
  localStorage.removeItem("user");
  localStorage.removeItem("isCustomer");
  window.location.reload();
}

function getCurrentUser() {
  try {
    const user = localStorage.getItem("user");
    return user;
  } catch (error) {
    return null;
  }
}
function loggedIn() {
  const loggedIn = localStorage.getItem("user");
  return loggedIn ? true : false;
}

function isCustomer() {
  const loggedIn = localStorage.getItem("isCustomer");
  return loggedIn === "true" ? true : false;
}

async function initStudentPortal() {
  if (!isCustomer())
    return showErrorToast("Only customers can use student portal!");
  let data = {};
  let user = getCurrentUser();

  const { data: response } = await http.post("/portal", data, {
    token: `Bearer ${user}`,
  });

  if (!response.success) return showErrorToast(response.message);
  else window.location.href = response.url;
  return response;
}

async function forgotPassword(user) {
  let formData = new FormData();
  formData.append("email", user.email);

  const { data: response } = await http.post("/users/forgotPassword", formData);
  return response;
}

async function resetPassword(user) {
  let formData = new FormData();
  formData.append("email", user.email);
  formData.append("token", user.token);

  const { data: response } = await http.post("/users/resetPassword", formData);
  return response;
}

async function changePassword(data) {
  const { data: response } = await http.put("/users/changePassword", data);
  return response;
}

export {
  login,
  logout,
  getCurrentUser,
  register,
  verifyAccount,
  loggedIn,
  isCustomer as checkIfCustomer,
  initStudentPortal,
  forgotPassword,
  resetPassword,
  changePassword,
};
